import { fetchAuthSession } from "aws-amplify/auth";
import { SystemError, SystemErrorTitle, SystemErrorMsg } from "../../constants";
import executeApi from './executeApi';
import { GetSearchResultApiRequest } from "../model/apiRequestModel";
import { GetSearchResultApiResponse } from "../model/apiResponseModel";

/** 検索結果取得 */
const getSearchResult = async (requestObj: GetSearchResultApiRequest): Promise<GetSearchResultApiResponse> => {
    // 認証
    const session = await fetchAuthSession();
    const jwtToken = session.tokens?.idToken?.toString();
    // EyesFrontAPIのURLを取得
    const baseURL = process.env.REACT_APP_EYES_FRONT_API_ROOT!;
    // 検索結果取得API PATH
    const path = "/search/result/execution";
    const request = JSON.stringify(requestObj)

    try {
        const response = await executeApi(baseURL, path, jwtToken, 0, request);
        // レスポンスコード返却
        if (!response || response.data.resCd === "") {
            return {
                resCd: SystemError,
                msgTitle: SystemErrorTitle,
                msg: SystemErrorMsg
            }
        } else {
            const result: GetSearchResultApiResponse = response.data
            return result
        }
    } catch (e) {
        return {
            resCd: SystemError,
            msgTitle: SystemErrorTitle,
            msg: SystemErrorMsg
        };
    }
};

export default getSearchResult;
